import { Fade, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import React, { useState } from "react";
import FlagIcon from "@mui/icons-material/Flag";
import MenuIcon from "@mui/icons-material/Menu";

function KpiTrackerOptions({ openDailyGoalModal }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleManageDailyGoals = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
    openDailyGoalModal();
  };

  return (
    <>
      <MoreHorizIcon
        sx={{
          p: 0,
          ":hover": {
            cursor: "pointer",
          },
        }}
        onClick={handleClick}
      >
        <MenuIcon />
      </MoreHorizIcon>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleManageDailyGoals}>
          <ListItemIcon>
            <FlagIcon />
          </ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
            Manage Daily Goals
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}

export default KpiTrackerOptions;
